import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCostcodeByIds } from '../costcodes/state/costcodes.actions';
import { COSTCODE_BY_IDS_COLUMNS, getReferencedCostcodeIds } from './reportHelpers';

export default function useReportCostcodes(timeEntryUserMap = {}) {
  const dispatch = useDispatch();
  const costcodeIdMap = useSelector((state) => state.costcodes.costcodeIdMap);

  const referencedIds = useMemo(
    () => getReferencedCostcodeIds(timeEntryUserMap),
    [timeEntryUserMap],
  );

  useEffect(() => {
    if (referencedIds.length) {
      dispatch(getCostcodeByIds(referencedIds, {
        columns: COSTCODE_BY_IDS_COLUMNS.PAYROLL,
      }));
    }
  }, [referencedIds, dispatch]);

  return costcodeIdMap;
}
